import { render, staticRenderFns } from "./ModalListaDocs_buscador.vue?vue&type=template&id=f1666b08&scoped=true&"
import script from "./ModalListaDocs_buscador.vue?vue&type=script&lang=js&"
export * from "./ModalListaDocs_buscador.vue?vue&type=script&lang=js&"
import style0 from "./ModalListaDocs_buscador.vue?vue&type=style&index=0&id=f1666b08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1666b08",
  null
  
)

export default component.exports